import { hqControlResultSchema } from '@kop/contracts';

export function createHqControlRepository(transport: { loadControl(query: { year: number; half: 1 | 2 }): Promise<unknown> }) {
  return { async load(year: number, half: 1 | 2) {
    const value = hqControlResultSchema.parse(await transport.loadControl({ year, half }));
    if (value.year !== year || value.half !== half) throw Error('HQ_CONTROL_PERIOD_MISMATCH');
    return value;
  } };
}
export function createFirebaseHqControlRepository() {
  const config = { projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '', apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '', appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '', authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '', appCheckSiteKey: import.meta.env.VITE_FIREBASE_APPCHECK_SITE_KEY ?? '' };
  if (import.meta.env.VITE_AUTH_ADAPTER !== 'firebase' || Object.values(config).some(value => !value.trim())) return null;
  const port = import('@kop/operations-firebase-adapter').then(module => module.createHqHalfyearReviewPort(config));
  return createHqControlRepository({ loadControl: async query => (await port).loadControl(query) });
}
export type HqControlRepository = ReturnType<typeof createHqControlRepository>;
